import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AcmicService, MapfreAlertComponent, MapfreLoadingComponent } from '@mapfre-design-library/src/public_api';
import { UserDataService } from '@services/data-services/user-data.service';
import { BillingNewService } from '@services/common/billing-new.service';
import { Capacitor } from '@capacitor/core';
import { EMPTY } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { ErrorRedirectionService } from '@services/error-service/error-redirection.service';
declare let OneInc: any;

@Component({
  selector: 'app-wallet-details',
  templateUrl: './wallet-details.component.html',
  styleUrls: ['./wallet-details.component.scss'],
  imports: [CommonModule, MapfreLoadingComponent, MapfreAlertComponent]
})
export class WalletDetailsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('portalOneContainer') containerRef: ElementRef;
  isOneIncPayment: boolean;
  isNativeApp: boolean;
  isAcmic: boolean;
  container: any;
  portalOne: any;
  referenceData3: string;
  customerID: string;
  userData: any;
  loading = true;

  constructor(
    private acmicServie: AcmicService,
    private router: Router,
    private billingNewService: BillingNewService,
    private userDataService: UserDataService,
    private errorRedirectionService: ErrorRedirectionService
  ) {
    this.isAcmic = this.acmicServie.isACMIC();
    this.userDataService.$userData.subscribe((res) => {
      this.userData = res;
    });
  }

  isNative() {
    this.isNativeApp = Capacitor.isNativePlatform();
  }

  addNewMethod() {
    const payload = {
      operation: 'managePaymentMethods',
      clientReferenceData3: this.referenceData3,
      clientReferenceData5: this.userData.userDetails.state
    };

    this.billingNewService.getOneIncTokens(payload)
      .pipe(
        tap(res => {
          if (!res?.PortalOneSessionKey || !res?.Token) {
            throw new Error('Missing session or token in response');
          }
          // console.log("Portal One Session Key : ", res.PortalOneSessionKey);
          // console.log("Portal One Token Key : ", res.Token);
        }),
        catchError(err => {
          // console.error('Payment init failed', err);
          this.errorRedirectionService.errorRedirectHandler(err);
          return EMPTY;
        })
      )
      .subscribe(res => {
        this.portalOne.run({
          sessionId: res.PortalOneSessionKey,
          accessTokenId: res.Token,
          displayMode: 'Inline',
          allowClosing: true,
          loadingIndication: false,
        });
      });
  }


  onClose() {
    this.router.navigate(['/profile']);
  }


  ngOnInit(): void {
    this.isNative();
    this.referenceData3 = this.isNativeApp ? 'B2C Mobile' : 'B2C';
  }

  ngAfterViewInit(): void {
    // Use @ViewChild instead of getElementById to guarantee we get THIS component's
    // own container — not a same-id element from a component still alive in the DOM
    // during Angular's navigate-in / navigate-out overlap (e.g. bn-make-a-payment-landing).
    this.container = this.containerRef.nativeElement;
    this.portalOne = new OneInc.PortalOne(
      this.container,
      this.subscribeToEvents(this.container)
    );
    this.addNewMethod();
   }

  subscribeToEvents(container: HTMLElement) {
    if (!container) {
      return;
    }
    container.addEventListener('portalOne.load', () => {
      this.loading = false;
    });
    container.addEventListener('portalOne.paymentComplete', (data) => {
      console.log('successfully payemnt done ', data);
    });
    container.addEventListener('portalOne.error', (err) => {
      console.log('err in payemnt done ', err);
    });
    container.addEventListener('portalOne.unload', () => {
      console.log(' portalOne.unload');
      this.onClose();
    });
  }

  ngOnDestroy() {
    if (this.container) {
      const newConatiner = this.container.cloneNode(true) as HTMLElement;
      this.container.replaceWith(newConatiner);
      this.container = null
    }
    this.billingNewService.setOneIncPaymentStatus(false);
  }
}